import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class useractivationService {

  private apiBaseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getUserActivationList(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/getUserActivationList',postData);
  }

  checkPwd(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/front/authService/checkPwd',postData);
  }

  toggleActive(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/toggleActive',postData)
  }

  toggleLocked(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/toggleLocked',postData);
  }

  toggleVerify(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/toggleVerify',postData);
  }

  searchByTypeNDate(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/searchByTypeNDate',postData);
  }

  GetSalesPersonList(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/GetSalesPersonList',postData);
  }

  changeSp(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/changeSp',postData);
  }

  deleteUser(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/deleteUser',postData)
  }

  updatePartyCode(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/updatePartyCode',postData);
  }

  changeCAT(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/changeCAT',postData);
  }

  LocalUserUpdate(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/LocalUserUpdate',postData);
  }

  SingleBrokUpdate(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/SingleBrokUpdate',postData);
  }

  UpdateOnlineDiscount(Data:any):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl+'/admin/discount_mast/addBulkDiscount',Data);
  }

  BasketMailFlagUpdate(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/BasketMailFlagUpdate',postData);
  }

  toggleLockedV2(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/toggleLockedV2',postData);
  }

  WRegistrationPurModeUpdate(postData):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl+'/admin/user_activation/WRegistrationPurModeUpdate',postData);
  }
}
